import { capitalizeFirstLetter } from "../util/GameUtil"
import Piece from "../components/piece/Piece";
import Block from "../components/block/Block";

import './GameBoard.css'

function GameBoard({ gameState, events }) {
    return (
        <div className="main">
            <div className='options'>
                <div className='option-button'>
                    <img src="/restart.svg" alt='restart' onClick={events.restartGame}></img>
                    <span>Restart</span>
                </div>
                {events.undoMove && <div className='option-button'>
                    <img src="/undo.svg" alt='undo' onClick={events.undoMove}></img>
                    <span>Undo</span>
                </div>}
            </div>

            <div className='gameStage'>
                <div className='result' style={{ visibility: gameState.result ? "visible" : "hidden" }}>
                    <h2 style={{ color: "#8B5A2B" }}>{gameState.result === "draw" ? `Game is ${capitalizeFirstLetter(gameState.result)}` : `${capitalizeFirstLetter(gameState.result)} player wins the game!`}</h2>
                </div>

                <div className='board'>
                    {
                        gameState.blocks.map((b, bIndex) => (
                            <Block block={b} key={bIndex} onClick={() => events.onPieceClick(b.x, b.y)} />
                        ))
                    }

                    {
                        gameState.pieces.map((p, pIndex) => (
                            <Piece piece={p} key={p.id} onClick={() => events.onPieceClick(p.x, p.y)} />
                        ))
                    }
                </div>
            </div>

        </div>
    )
}

export default GameBoard;